import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class EmandateUrlUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getEmandateUrl(req);
    }
}
export default EmandateUrlUseCase;
